import React, { useEffect, useState } from 'react'
import Menu from '../../components/Menu'
import Header from '../../components/Header'
import { withPaddingPage } from '../../config/Util'
import Strings from '../../config/Strings'
import AccountInfo from '../../components/AccountInfo'
import { useHistory } from 'react-router-dom'
import Dialog from '../../components/Dialog'
import ReactRoutes from '../../config/ReactRoutes'
import { AccountService } from '../../services/AccountService'

function ChangePassword(props) {

    withPaddingPage()

    const [oldPassword, setOldPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [newPasswordConfirm, setNewPasswordConfirm] = useState("")
    const [showDialog, setShowDialog] = useState(false)
    const [dialogData, setDialogData] = useState({})
    const [showErrorDialog, setShowErrorDialog] = useState(false)
    const [errorDialogData, setErrorDialogData] = useState({})

    const history = useHistory()

    useEffect(() => {

    }, [])

    function changePassword(e) {
        if (validateInput()) {
            let targetClassList = e.target.classList;
            targetClassList.add("spinner")
            
            AccountService.changePassword(oldPassword, newPassword)
                .then(response => {
                    if (response === "novasifraupisana") {
                        setDialogData({
                            title: Strings.PASSWORD_CHANGED
                        })
                        setShowDialog(true)
                    } else {
                        setErrorDialogData({
                            title: response
                        })
                        setShowErrorDialog(true)
                    }
                    targetClassList.remove("spinner")
                })
                .catch(error => {
                    console.log(error)
                    targetClassList.remove("spinner")
                })
        }
    }

    function validateInput() {
        let valid = true

        if (!oldPassword || !newPassword || !newPasswordConfirm) {
            valid = false
            setErrorDialogData({
                title: Strings.ERROR_MUST_FILL_ALL_FIELDS
            })
        } else if (newPassword !== newPasswordConfirm) {
            valid = false
            setErrorDialogData({
                title: Strings.PASSWORDS_DO_NOT_MATCH
            })
        }

        setShowErrorDialog(!valid)
        return valid
    }

	return (
        <div>
            <Header back={ () => history.goBack() } text={Strings.CHANGE_PASSWORD} />
            <AccountInfo
                name={props.sessionData.name}
                lastName={props.sessionData.lastName}
                telephone={props.sessionData.telephone}
                email={props.sessionData.email}
                companyName={props.sessionData.companyName}   
            />

            <input onChange={ (e) => setOldPassword(e.target.value) } className="input show-animation" placeholder="Stara lozinka" type="password" />
			<input onChange={ (e) => setNewPassword(e.target.value) } className="input show-animation" placeholder="Nova lozinka" type="password" />
            <input onChange={ (e) => setNewPasswordConfirm(e.target.value) } className="input show-animation" placeholder="Potvrdite novu lozinku" type="password" />

            <button onClick={changePassword} className="btn btn-green mt2rem show-animation">{Strings.SAVE}</button>

            <Menu active="account" />

            {
				showDialog ? <Dialog primaryText={Strings.OK} primaryAction={ () => history.push(ReactRoutes.ACCOUNT) } data={dialogData} /> : null
			}

            {
				showErrorDialog ? <Dialog primaryText={Strings.OK} primaryAction={ () => setShowErrorDialog(false) } data={errorDialogData} /> : null
			}
        </div>
	)
}

export default ChangePassword
